// extracted by mini-css-extract-plugin
export default {"graphic":"StepsSummary_graphic_qIfs3","text":"StepsSummary_text_aC6RD"};